const isLocalhost = () =>
  Boolean(
    window.location.hostname === "localhost" ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === "[::1]" ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
  );

export const URL = "/api";
export const LOGIN = "/auth";

export const PROFILE_PATH = "/profile/profile";
export const CHANGE_PASSWORD_PATH = "/profile/change_password";
export const ORGANIZATION_PATH = "/organization/organization";
export const ORGANIZATION_CHANGE_CAPABILITY_PATH = uuid =>
  "/organization/user/" + uuid + "/change_capability";
export const ORGANIZATION_MAKE_OWNER_PATH = uuid =>
  "/organization/user/" + uuid + "/make_owner";
export const ORGANIZATION_MAKE_PRIMARY_OWNER_PATH = uuid =>
  "/organization/user/" + uuid + "/make_primary_owner";
export const ORGANIZATION_ADD_BANK_PATH = "/organization/bank/add";
export const ORGANIZATION_BANK_PATH = uuid => "/organization/bank/" + uuid;

export const REIMBURSEMENT_OVERVIEW_PATH = "/reimbursements/overview";
export const REIMBURSEMENT_SUBMITTERS_PATH = "/reimbursements/submitters";
export const REIMBURSEMENT_SUBMITTER_PATH = submitter_uuid =>
  "/reimbursements/submitter/" + submitter_uuid;
export const REIMBURSEMENT_ITEMS_PATH = "/reimbursements/items";
export const REIMBURSEMENT_ITEM_PATH = reimbursement_uuid =>
  "/reimbursements/item/" + reimbursement_uuid;
export const REIMBURSEMENT_MARK_PAID_PATH = "/reimbursements/items/mark_paid";
export const REIMBURSEMENT_SUBMITTERS_PUBLIC_JOIN_LINK =
  "/reimbursements/submitters/public_join";

export const TRANSACTIONS_OVERVIEW_PATH = "/transactions/overview";
export const TRANSACTIONS_REFRESH_PATH = "/transactions/refresh";

export const UNAUTHED_REIMBURSEMENT_PATH = uuid => "/_/reimbursement/" + uuid;
export const UNAUTHED_REIMBURSEMENT_SUBMIT_PATH = uuid =>
  "/_/reimbursement/" + uuid + "/submit";
export const UNAUTHED_SUBMITTER_PATH = uuid => "/_/submitter/" + uuid;

export const UNAUTHED_ORGANIZATION_PATH = uuid => "/_/organization/" + uuid;
export const UNAUTHED_ORGANIZATION_ADD_SUBMITTER_PATH = uuid =>
  "/_/organization/" + uuid + "/add_submitter";

export const PLAID_WEBHOOK_URL = () =>
  isLocalhost() ? null : window.location.origin + "/api/plaid/webhook";



// WEBPACK FOOTER //
// ./frontend/src/config/Api.js